import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { LabelBox } from '../Box/LabelBox';
import { TextInputBox } from '../Box/TextInputBox';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { axiosInstance } from '../../functions/axios';
import { HoverTip } from '../HoverTip/HoverTip';
import { InlineNotificationComponent } from '../Notification/InlineNotificationComponent';
import { Box, Button, Field, FieldLabel, Grid, Text, TextInput, Typography, ContextualNotification } from '@blueprint/ui';
import { NativeDropdown } from '../NativeDropdown/NativeDropdown';

const StyledDiv = styled.div`
    padding-top: 100px;
    padding-left: 5vw;
    padding-right: 5vw;
    padding-bottom: 5em;
`;

const ForgotPassword = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const globalState = useSelector((state) => state);
    const footerHeight = globalState.beneDetails.footerHeight;
    const [showPasswordField, setShowPasswordField] = useState(false);
    const [hideButtonsOne, setHideButtonsOne] = useState(true);
    const [hideButtonsTwo, setHideButtonsTwo] = useState(false);
    const [hideButtonsThree, setHideButtonsThree] = useState(false);
    const [hideButtonsFour, setHideButtonsFour] = useState(false);
    const [showQuestions, setShowQuestions] = useState(false);

    // For showing and setting Email Id and Error
    const [email, setEmail] = useState('');
    const [showEmailError, setShowEmailError] = useState(false);
    const [emailError, setEmailError] = useState('');

    // For showing and setting Email Id and Error
    const [otp, setOtp] = useState('');
    const [showOtpError, setShowOtpError] = useState(false);
    const [otpError, setOtpError] = useState('');
    const [workflowId, setWorkflowId] = useState('');

    // Screen Error
    const [showErrorRed, setShowErrorRed] = useState(false);
    const [showMsgGreen, setShowMsgGreen] = useState(false);
    const [showErrorLabel, setShowErrorLabel] = useState(false);

    // QUE AND ANS
    const [queList, setQueList] = useState([]);
    const [que, setQue] = useState('');
    const [ans, setAns] = useState('');
    const [showAnsError, setShowAnsError] = useState(false);
    const [showQueError, setShowQueError] = useState(false);
    const [ansErrorLabel, setAnsErrorLabel] = useState('');
    const [queErrorLabel, setQueErrorLabel] = useState('');

    useEffect(() => console.log('Logging selected question', que), [que]);

    // Password and confirm passwords
    const [newPwd, setNewPwd] = useState('');
    const [cnfPwd, setCnfPwd] = useState('');
    const [newPwdError, setNewPwdError] = useState(false);
    const [newPwdErrorLabel, setNewPwdErrorLabel] = useState('');
    const [newCnfError, setCnfPwdError] = useState(false);
    const [newCnfErrorLabel, setCnfPwdErrorLabel] = useState('');

    //API URL's
    const SEND_OTP_URL = process.env.REACT_APP_FG_SEND_OTP_URL;
    const VALIDATE_OTP_URL = process.env.REACT_APP_FG_VALIDATE_OTP_URL;
    const GET_SEC_QUES_URL = process.env.REACT_APP_FG_SEC_QUE_URL;
    const SEC_QUE_VALIDATE_URL = process.env.REACT_APP_FG_SEC_QUE_VALIDATE_URL;
    const RESET_PWD_URL = process.env.REACT_APP_FG_RESET_PWD_URL;
    const FORGOT_PASSWORD_TIMEOUT = process.env.REACT_APP_FORGOT_PASSWORD_TIMEOUT;

    // FOR DISABLING FIELDS
    const [disable, setDisable] = useState({
        email: false,
        otp: false,
        que: false,
        ans: false,
    });

    //VALIDATING EMAIL ID
    const validateEmail = () => {
        if (email.trim() === '' || email === null) {
            setShowEmailError(true);
            setEmailError(t('forgotPassword.email_error'));
            return false;
        }
        if (email.trim() !== '' && email.trim() !== null) {
            let pattern = new RegExp(
                /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
            );

            if (!pattern.test(email)) {
                setShowEmailError(true);
                setEmailError(t('forgotPassword.invalid_email_error'));
                return false;
            } else {
                setShowEmailError(false);
                return true;
            }
        }
    };

    const [timerStarted, setTimerStarted] = useState(false);
    useEffect(() => {
        var timer;
        if (timerStarted) {
            var time = new Date();
            console.log(`Starting timer for ${FORGOT_PASSWORD_TIMEOUT} minutes`);
            console.log(time.getHours() + ':' + time.getMinutes() + ':' + time.getSeconds());
            timer = setTimeout(() => {
                console.log('Push user to home page');
                let modalMessage = t('forgotPassword.yourOnlineSessionTimedOut');
                history.push({
                    pathname: '/login',
                    state: {
                        showModal: true,
                        modalMessage: modalMessage,
                    },
                });
            }, FORGOT_PASSWORD_TIMEOUT * 1000 * 60);
        } else {
            console.log('Not starting timer');
        }
        return () => clearTimeout(timer);
    }, [timerStarted]);

    //API SERVICE FOR SENDING OR RESENDING OTP
    const callSendOtp = async () => {
        try {
            const response = await axiosInstance({
                method: 'post',
                url: SEND_OTP_URL,
                data: JSON.stringify({
                    emailId: email,
                }),
            });
            if (response.status === 200) {
                console.log('Response from SEND_OTP_URL', response);
                setTimerStarted(true);
                setDisable({
                    ...disable,
                    email: true,
                });
                setShowMsgGreen(true);
                setShowErrorLabel(response.data.message);
                setShowPasswordField(true);
                setHideButtonsTwo(true);
                setHideButtonsOne(false);
            }
        } catch (error) {
            if (error && error.response.status === 400) {
                console.log('Error from SEND_OTP_URL', error);
            }
            if (error && error.response.status === 401) {
                history.push('/login');
            }
        }
    };

    //ON SUBMIT OF EMAIL
    const callEmailSubmit = () => {
        let validated = true;
        validated = validateEmail();

        if (validated === true) {
            callSendOtp();
        } else {
            let elementsWithError = document.getElementsByClassName('hasError');
            setTimeout(() => {
                console.log('Logging first element having class hasError', elementsWithError[0]);
                elementsWithError[0].focus();
            }, 200);
        }
    };

    // FUNCTION FOR RESENDING OTP
    const callResendOtp = () => {
        callSendOtp();
    };

    //VALIDATING OTP
    const validateOtp = () => {
        if (otp.trim() === '' || otp === null) {
            setShowOtpError(true);
            setOtpError(t('forgotPassword.pwd_error'));
            return false;
        } else {
            setShowOtpError(false);
            return true;
        }
    };

    //ON SUBMIT OF OTP
    const callOtpSubmit = () => {
        let validated = true;
        validated = validateOtp();

        if (validated === true) {
            const callValidateOtp = async () => {
                try {
                    const response = await axiosInstance({
                        method: 'post',
                        url: VALIDATE_OTP_URL,
                        data: JSON.stringify({
                            emailId: email,
                            otp: otp,
                        }),
                    });
                    if (response.status === 200) {
                        console.log('Response from VALIDATE_OTP_URL', response.data.workFlowId);
                        setDisable({
                            ...disable,
                            otp: true,
                        });
                        setWorkflowId(response.data.workFlowId);
                        setShowMsgGreen(false);
                        setShowPasswordField(true);
                        setShowQuestions(true);
                        setHideButtonsOne(false);
                        setHideButtonsTwo(false);
                        setHideButtonsThree(true);
                        fetchSecQues(response.data.workFlowId);
                    }
                } catch (error) {
                    if (error && error.response.status === 401) {
                        history.push('/login');
                    }
                    if (error && error.response.status === 400) {
                        setShowMsgGreen(false);
                        setShowOtpError(true);
                        setOtpError(error.response.data.message);
                        console.log('Error from SEND_OTP_URL', error);
                    }
                }
            };
            callValidateOtp();
        } else {
            let elementsWithError = document.getElementsByClassName('hasError');
            setTimeout(() => {
                console.log('Logging first element having class hasError', elementsWithError[0]);
                elementsWithError[0].focus();
            }, 200);
        }
    };

    //FETCHING SECURITY QUESTIONS
    const fetchSecQues = async (workflowId) => {
        try {
            const response = await axiosInstance({
                method: 'post',
                url: GET_SEC_QUES_URL,
                data: JSON.stringify({
                    emailId: email,
                    workFlowId: workflowId,
                }),
            });
            if (response.status === 200) {
                console.log('Response from SEND_OTP_URL', response);
                setQueList(
                    response.data.map((que) => ({
                        label: que.question,
                        value: que.id,
                    }))
                );
            }
        } catch (error) {
            if (error && error.response.status === 401) {
                history.push('/login');
                console.log('Error from SEND_OTP_URL', error);
            }
        }
    };

    //VALIDATING ANS
    const validateAns = () => {
        if (ans.trim() === '' || ans === null) {
            setShowAnsError(true);
            setAnsErrorLabel(t('forgotPassword.ans_error'));
            return false;
        } else {
            setShowAnsError(false);
            return true;
        }
    };

    //ON SUBMIT OF SECURITY DETAILS
    const callSecDetailsSubmit = () => {
        let validated = {
            que: true,
            ans: true,
        };
        validated.ans = validateAns();
        console.log('Logging selected security question before validating', que);

        if (que === '' || que.value === '' || que.value === null) {
            validated.que = false;
            setShowQueError(true);
            setQueErrorLabel(t('forgotPassword.questionShouldNotBeEmpty'));
        } else {
            setShowQueError(false);
        }

        if (validated.que === true && validated.ans === true) {
            const callValidateSec = async () => {
                try {
                    const response = await axiosInstance({
                        method: 'post',
                        url: SEC_QUE_VALIDATE_URL,
                        data: JSON.stringify({
                            emailId: email,
                            answer: ans,
                            qid: que.value,
                            workFlowId: workflowId,
                        }),
                    });
                    if (response.status === 200) {
                        console.log('Response from SEC_QUE_VALIDATE_URL', response);
                        setDisable({
                            ...disable,
                            que: true,
                            ans: true,
                        });
                        setShowPasswordField(true);
                        setHideButtonsOne(false);
                        setHideButtonsThree(false);
                        setHideButtonsFour(true);
                    }
                } catch (error) {
                    if (error && error.response.status === 400) {
                        setShowAnsError(true);
                        setAnsErrorLabel(error.response.data.message);
                        console.log('Error from SEND_OTP_URL', error);
                    }
                    if (error && error.response.status === 401) {
                        history.push('/login');
                    }
                }
            };
            callValidateSec();
        } else {
            let elementsWithError = document.getElementsByClassName('hasError');
            setTimeout(() => {
                console.log('Logging first element having class hasError', elementsWithError[0]);
                elementsWithError[0].focus();
            }, 200);
        }
    };

    //VALIDATING NEW PASSWORD
    const validatePwd = () => {
        if (newPwd.trim() === '' || newPwd === null) {
            setNewPwdError(true);
            setNewPwdErrorLabel(t('forgotPassword.pwd_error'));
            return false;
        }
        if (newPwd.trim() !== '' && newPwd !== null) {
            let pattern = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\-!@#$%^&*|(~=._)?]).{8,30}$');

            if (!pattern.test(newPwd)) {
                setNewPwdError(true);
                setNewPwdErrorLabel(t('forgotPassword.invalid_pwd_error'));
                return false;
            } else {
                setNewPwdError(false);
                return true;
            }
        }
    };

    //VALIDATING CONFIRM PASSWORD
    const validateCnfPwd = () => {
        if (cnfPwd.trim() === '' || cnfPwd === null) {
            setCnfPwdError(true);
            setCnfPwdErrorLabel(t('forgotPassword.cnfpwd_error'));
            return false;
        }
        if (cnfPwd.trim() !== '' && cnfPwd !== null) {
            let pattern = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\-!@#$%^&*|(~=._)?]).{8,30}$');

            if (!pattern.test(cnfPwd)) {
                setCnfPwdError(true);
                setCnfPwdErrorLabel(t('forgotPassword.invalid_cnfpwd_error'));
                return false;
            } else {
                setCnfPwdError(false);
                return true;
            }
        }
    };

    // RESET PASSWORD API CALL
    const callFinalSubmit = () => {
        let validated = {
            pwd: true,
            cnfPwd: true,
        };

        validated.pwd = validatePwd();
        validated.cnfPwd = validateCnfPwd();
        console.log('resp is', validated);

        if (newPwd !== cnfPwd) {
            setShowErrorRed(true);
            setShowErrorLabel(t('forgotPassword.passwordAndConfirmPassword'));
            validated.pwd = false;
        } else {
            setShowErrorRed(false);
        }
        if (validated.pwd === true && validated.cnfPwd === true) {
            const callResetPwd = async () => {
                try {
                    const response = await axiosInstance({
                        method: 'post',
                        url: RESET_PWD_URL,
                        data: JSON.stringify({
                            emailId: email,
                            password: newPwd,
                            workFlowId: workflowId,
                        }),
                    });
                    if (response.status === 200) {
                        history.push('/login');
                    }
                } catch (error) {
                    if (error && error.response.status === 400) {
                        setShowErrorRed(true);
                        console.log("the path is",error.response.data.message);
                        if(error.response.data.message === undefined)
                            setShowErrorLabel(error.response.data.errors[0].message);
                        else {
                            setShowErrorLabel(error.response.data.message);
                        }
                        setAnsErrorLabel(error.response.data.message);
                        console.log('Error from RESET_PWD_URL', error);
                    }
                    if (error && error.response.status === 401) {
                        history.push('/login');
                    }
                }
            };
            callResetPwd();
        } else {
            let elementsWithError = document.getElementsByClassName('hasError');
            setTimeout(() => {
                if (elementsWithError !== null && elementsWithError !== undefined && elementsWithError.length > 0) {
                    console.log('Logging first element having class hasError', elementsWithError[0]);
                    elementsWithError[0].focus();
                }
            }, 200);
        }
    };

    return (
        <StyledDiv style={{ paddingBottom: `${footerHeight + 20}px` }}>
            <Grid container>
                <Grid container>
                    <Box borderLeft='3px solid red' margin='0 0 2vw 0' paddingLeft='10px'>
                        <Typography variant='h1' className='page-title' tabIndex='-1'>
                            {t('forgotPassword.section_title')}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Box marginTop={['10px', '10px', '10px', '24px']}>
                        <Typography variant='body1'>{t('forgotPassword.label')}</Typography>
                    </Box>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sm={6}>
                        {showErrorRed === true ? (
                            <ContextualNotification
                                id='fg-red-error'
                                title=''
                                variant='error'
                                iconAriaLabel='error'
                                marginTop={4}
                                onClose={() => setShowErrorRed(false)}
                            >
                                {showErrorLabel}
                            </ContextualNotification>
                        ) : null}
                        {showMsgGreen === true ? (
                            <ContextualNotification
                                id='fg-green-error'
                                title=''
                                variant='success'
                                iconAriaLabel='success'
                                marginTop={4}
                                onClose={() => setShowMsgGreen(false)}
                            >
                                {showErrorLabel}
                            </ContextualNotification>
                        ) : null}
                    </Grid>
                </Grid>
                <Grid container>
                    <Field name='fp-textBox-email'>
                        <Grid item xs={12} sm={2}>
                            <LabelBox>
                                <FieldLabel variant='body1'>{t('forgotPassword.email')} *</FieldLabel>
                            </LabelBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextInputBox>
                                <TextInput
                                    className={showEmailError ? 'hasError' : ''}
                                    placeholder='Please Enter Email'
                                    onChange={(event) => {
                                        setEmail(event.value);
                                    }}
                                    disabled={disable.email}
                                    value={email}
                                    onBlur={() => {
                                        setTimeout(validateEmail, 500);
                                    }}
                                    invalid={showEmailError}
                                    aria-describedby='fp-inline-error-email'
                                />
                                {showEmailError ? <InlineNotificationComponent id='fp-inline-error-email' title='' content={emailError} /> : null}
                            </TextInputBox>
                        </Grid>
                    </Field>
                </Grid>
                {showPasswordField ? (
                    <Grid container>
                        <Field name='fp-textfield-otp'>
                            <Grid item xs={12} sm={2}>
                                <LabelBox>
                                    <FieldLabel variant='body1'>{t('forgotPassword.otp')} *</FieldLabel>
                                </LabelBox>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInputBox>
                                    <TextInput
                                        className={showOtpError ? 'hasError' : ''}
                                        type='password'
                                        disabled={disable.otp}
                                        placeholder='Please enter one time password'
                                        onChange={(event) => {
                                            setOtp(event.value);
                                        }}
                                        value={otp}
                                        onBlur={() => {
                                            setTimeout(validateOtp, 500);
                                        }}
                                        invalid={showOtpError}
                                        aria-describedby='fp-inline-error-otp'
                                    />
                                    {showOtpError ? <InlineNotificationComponent id='fp-inline-error-otp' title='' content={otpError} /> : null}
                                </TextInputBox>
                                {hideButtonsTwo ? (
                                    <Button
                                        id='fg-button-resend-otp'
                                        marginTop={['5px', '5px', '5px', '10px']}
                                        variant='light.tertiary'
                                        onClick={() => {
                                            callResendOtp();
                                        }}
                                    >
                                        {t('forgotPassword.resend_button')}
                                    </Button>
                                ) : null}
                            </Grid>
                        </Field>
                    </Grid>
                ) : null}
                {showQuestions ? (
                    <>
                        <Grid container>
                            <Field name='fp-dropdown-que'>
                                <Grid item xs={12} sm={2}>
                                    <LabelBox>
                                        <FieldLabel variant='body1'>{t('forgotPassword.sec_question')} *</FieldLabel>
                                    </LabelBox>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextInputBox>
                                        <NativeDropdown
                                            className={showQueError ? 'hasError' : ''}
                                            disabled={disable.que}
                                            id='fp-dropdown-que-field'
                                            width='100%'
                                            options={queList}
                                            invalid={showQueError}
                                            onChange={(SelectedOption) => {
                                                console.log('Logging option user selected from dropdown from onChange', SelectedOption);

                                                setQue(SelectedOption);
                                            }}
                                            aria-describedby='fp-inline-error-que'
                                        />
                                        {/**                                        <ReactSelect

                                            className={showQueError ? 'hasError' : ''}
                                            isDisabled={disable.que}
                                            id='fp-dropdown-que-field'
                                            value={que}
                                            width='100%'
                                            isSearchable
                                            options={queList}
                                            invalid={showQueError}
                                            onChange={(SelectedOption) => setQue(SelectedOption)}
                                            aria-describedby='fp-inline-error-que'
                                        /> */}
                                    </TextInputBox>
                                    {showQueError ? <InlineNotificationComponent id='fp-inline-error-que' title='' content={queErrorLabel} /> : null}
                                </Grid>
                            </Field>
                        </Grid>
                        <Grid container>
                            <Field name='fp-textfield-ans'>
                                <Grid item xs={12} sm={2}>
                                    <LabelBox>
                                        <FieldLabel variant='body1'>{t('forgotPassword.ans')} *</FieldLabel>
                                    </LabelBox>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextInputBox>
                                        <TextInput
                                            className={showAnsError ? 'hasError' : ''}
                                            disabled={disable.ans}
                                            onChange={(event) => {
                                                setAns(event.value);
                                            }}
                                            onBlur={() => {
                                                setTimeout(validateAns, 500);
                                            }}
                                            value={ans}
                                            invalid={showAnsError}
                                            aria-describedby='fp-inline-error-ans'
                                        />
                                    </TextInputBox>
                                    {showAnsError ? <InlineNotificationComponent id='fp-inline-error-ans' title='' content={ansErrorLabel} /> : null}
                                </Grid>
                            </Field>
                        </Grid>
                    </>
                ) : null}

                {hideButtonsFour ? (
                    <>
                        <Grid container>
                            <Field name='fp-textfield-newPwd'>
                                <Grid item xs={12} sm={2}>
                                    <LabelBox>
                                        <FieldLabel variant='body1'>{t('forgotPassword.password')} *&nbsp;</FieldLabel>
                                        <HoverTip
                                            content={t('registrationPageOne.tooltip1')}
                                            ariaLabel={t('registrationPageOne.tooltip1_info')}
                                            id='forgotPassword-tooltip-newPassword'
                                        ></HoverTip>
                                    </LabelBox>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextInputBox>
                                        <TextInput
                                            className={newPwdError ? 'hasError' : ''}
                                            type='password'
                                            placeholder='Please enter password'
                                            onChange={(event) => {
                                                setNewPwd(event.value);
                                            }}
                                            value={newPwd}
                                            onBlur={() => {
                                                setTimeout(validatePwd, 500);
                                            }}
                                            invalid={newPwdError}
                                            aria-describedby='fp-inline-error-newPwd'
                                        />
                                        {newPwdError ? (
                                            <InlineNotificationComponent id='fp-inline-error-newPwd' title='' content={newPwdErrorLabel} />
                                        ) : null}
                                    </TextInputBox>
                                </Grid>
                            </Field>
                        </Grid>
                        <Grid container>
                            <Field name='fp-textfield-cnfPwd'>
                                <Grid item xs={12} sm={2}>
                                    <LabelBox>
                                        <FieldLabel variant='body1'>{t('forgotPassword.confirm_password')} *</FieldLabel>
                                    </LabelBox>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextInputBox>
                                        <TextInput
                                            className={newCnfError ? 'hasError' : ''}
                                            type='password'
                                            placeholder='Please enter confirm password'
                                            onChange={(event) => {
                                                setCnfPwd(event.value);
                                            }}
                                            value={cnfPwd}
                                            onBlur={() => {
                                                setTimeout(validateCnfPwd, 500);
                                            }}
                                            invalid={newCnfError}
                                            aria-describedby='fp-inline-error-cnfPwd'
                                        />
                                        {newCnfError ? (
                                            <InlineNotificationComponent id='fp-inline-error-cnfPwd' title='' content={newCnfErrorLabel} />
                                        ) : null}
                                    </TextInputBox>
                                </Grid>
                            </Field>
                        </Grid>
                    </>
                ) : null}

                <Grid container>
                    <Grid item xs={12} sm={6}>
                        <Box
                            display='flex'
                            flexDirection='row'
                            justifyContent='space-between'
                            width='100%'
                            maxWidth='650px'
                            paddingTop='1em'
                            mt={4}
                            borderTop='1px solid #333'
                        >
                            <Button id='fg-button-cancel' variant='light.tertiary' onClick={() => history.push('/login')}>
                                {t('forgotPassword.cancel_button')}
                            </Button>

                            {hideButtonsOne ? (
                                <Button
                                    id='fg-button-submit-email'
                                    variant='light.primary'
                                    type='submit'
                                    onClick={() => {
                                        callEmailSubmit();
                                    }}
                                >
                                    {t('forgotPassword.submit_button')}
                                </Button>
                            ) : null}

                            {hideButtonsTwo ? (
                                <Button
                                    id='fg-button-otp-submit'
                                    variant='light.primary'
                                    onClick={() => {
                                        callOtpSubmit();
                                    }}
                                >
                                    {t('forgotPassword.submit_button')}
                                </Button>
                            ) : null}

                            {hideButtonsThree ? (
                                <Button
                                    id='fg-button-sec-submit'
                                    variant='light.primary'
                                    onClick={() => {
                                        callSecDetailsSubmit();
                                    }}
                                >
                                    {t('forgotPassword.submit_button')}
                                </Button>
                            ) : null}

                            {hideButtonsFour ? (
                                <Button
                                    id='fg-button-reset-pwd'
                                    variant='light.primary'
                                    onClick={() => {
                                        callFinalSubmit();
                                    }}
                                >
                                    {t('forgotPassword.submit_button')}
                                </Button>
                            ) : null}
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </StyledDiv>
    );
};

export default ForgotPassword;
